import type { NotifyPort } from '@/features/messages/domain/notify'
import type { TimeOffPort, TimeOffRequest } from '../domain/timeoff'

const getTimeOffRequest = async (
	port: TimeOffPort,
	id: string,
	notify: NotifyPort,
): Promise<TimeOffRequest | null> => {
	try {
		return await port.getRequestById(id)
	} catch {
		notify.error('hr.timeOffRequestLoadFailed')
		throw new Error('Failed to load time-off request.')
	}
}

export { getTimeOffRequest }
